import React, { FC, PropsWithChildren, useCallback, useEffect } from 'react';

import { isClickedOutside } from './ClickOutside.utils';

interface IClickOutsideProps {
  reference?: HTMLElement | null;
  target?: HTMLElement | (HTMLElement | null)[] | null;
  onClickOutside?(e: MouseEvent): void;
}

// TODO: If onClickOutside is undefined, we should no listen click events. Or we should add disabled prop
export const ClickOutside: FC<PropsWithChildren<IClickOutsideProps>> = (props) => {
  const onClick = useCallback(
    (e: MouseEvent): void => {
      if (!props.reference) {
        return;
      }
      const targetElement = props.target;
      const referenceElement = props.reference;
      const clickedElement = e.target as HTMLElement;
      if (
        props.onClickOutside &&
        isClickedOutside(clickedElement, referenceElement, targetElement as HTMLElement)
      ) {
        props.onClickOutside(e);
      }
    },
    [props.reference, props.target]
  );

  useEffect(() => {
    document.addEventListener('click', onClick);
    document.addEventListener('contextmenu', onClick);

    return () => {
      document.removeEventListener('click', onClick);
      document.removeEventListener('contextmenu', onClick);
    };
  }, [onClick]);
  return <>{props.children}</>;
};
